import { render, staticRenderFns } from "./PresentationVideo.vue?vue&type=template&id=6d64086f&"
import script from "./PresentationVideo.vue?vue&type=script&lang=js&"
export * from "./PresentationVideo.vue?vue&type=script&lang=js&"
import style0 from "./PresentationVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports